import React, { useEffect, useMemo, useState } from "react";
import {
  useGetBasicDetailsMutation,
  useGetRpdPollingMutation,
} from "../lib/services/eligibilityApi";
import { useLocation, useNavigate } from "react-router-dom";
import CenteredPopup from "../components/popups/CenteredPopup";
import { ReactComponent as WarningIcon } from "../images/warning-icon.svg";

const LoadingScreen = () => {
  const [getBasicDetails] = useGetBasicDetailsMutation();
  const [getRpdPolling] = useGetRpdPollingMutation();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const jwt = useMemo(() => queryParams.get("jwt_token"), [queryParams]);
  const secret = useMemo(() => queryParams.get("secret"), [queryParams]);
  const deviceid = useMemo(() => queryParams.get("device_id"), [queryParams]);

  const [error, setError] = useState("");
  const [isModalOpen, setIsModalopen] = useState(false);

  const getBasicDetailsAPI = async () => {
    try {
      let jwt_token;
      if (jwt) {
        jwt_token = jwt;
        localStorage.setItem("jwt", jwt);
      } else {
        jwt_token = localStorage.getItem("jwt");
      }
      const scrt = secret ? secret : localStorage.getItem("secret");
      const result = await getBasicDetails({ jwt_token, scrt });
      if (result.data && result.data.status === "error") {
        if (result.data.message === "Login expired! Please re-login.") {
          localStorage.removeItem("jwt");
          localStorage.removeItem("lastVisitedPage");
          const phone = localStorage.getItem("phone");
          localStorage.clear();
          phone ? navigate(`/?phone=${phone}`) : navigate("/");
        }
      } else if (result.data && result.data.http_code === "201") {
        if (result.data.message === "Login expired! Please re-login.") {
          localStorage.removeItem("lastVisitedPage");
          const phone = localStorage.getItem("phone");
          phone ? navigate(`/?phone=${phone}`) : navigate("/");
        }
      } else {
        if (result.error) {
          setError("Something went wrong. Please try again later.");
          setIsModalopen(true);
        } else {
          window.location.href = result.data.redirect_url;
        }
      }
    } catch (error) {
      setError("Something went wrong. Please try again later.");
      setIsModalopen(true);
    }
  };

  const getRpdPollingAPI = async () => {
    try {
      let jwt_token;
      if (jwt) {
        jwt_token = jwt;
        localStorage.setItem("jwt", jwt);
      } else {
        jwt_token = localStorage.getItem("jwt");
      }
      const scrt = secret ? secret : localStorage.getItem("secret");
      const dvcId = deviceid ? deviceid : localStorage.getItem("device_id");
      const result = await getRpdPolling({
        jwt_token,
        scrt,
        device_id: dvcId,
      });
      if (result.data && result.data.status === "error") {
        setError(result.data.message);
        if (result.data.message === "Login expired! Please re-login.") {
          localStorage.removeItem("jwt");
          localStorage.removeItem("lastVisitedPage");
          const phone = localStorage.getItem("phone");
          phone ? navigate(`/?phone=${phone}`) : navigate("/");
        }
        setIsModalopen(true);
      } else if (
        result.data &&
        result.data.message === "Login expired! Please re-login."
      ) {
        setError(result.data.message);
        localStorage.removeItem("jwt");
        localStorage.removeItem("lastVisitedPage");
        const phone = localStorage.getItem("phone");
        phone ? navigate(`/?phone=${phone}`) : navigate("/");
      } else if (result.error) {
        setError(
          result?.error?.data?.error_message ||
            result?.error?.data?.message ||
            "Please check your internet or try again later."
        );
        setIsModalopen(true);
      } else {
        if (
          result?.data &&
          (result?.data?.status === "manual" ||
            result?.data?.status === "success")
        ) {
          await getBasicDetailsAPI();
        } else {
          setTimeout(() => {
            getRpdPollingAPI();
          }, 3000);
        }
      }
    } catch (error) {
      setError("Something went wrong. Please try again later.");
      setIsModalopen(true);
    }
  };

  useEffect(() => {
    getRpdPollingAPI();
  }, []);

  const handleClose = () => {
    setIsModalopen(false);
    setError("");
    getRpdPollingAPI();
  };

  const errorModalButtons = [{ label: "Retry", onClick: handleClose }];

  return (
    <div
      style={{
        display: "flex",
        backgroundColor: "#c3c3c342",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CenteredPopup
        isOpen={isModalOpen}
        buttons={errorModalButtons}
        onClose={handleClose}
        icon={<WarningIcon />}
      >
        <p>{error}</p>
      </CenteredPopup>
      {error && <div className="error ps-0 pb-2">{error}</div>}
      {!error && (
        <div className="loader-wrapper">
          <div className="loader-content">
            <div className="loader"></div>
            <p>Fetching updated status— please wait...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoadingScreen;
